/* ============================================================
   MY TELLURIDE CHRISTMAS — cart behaviour
   Progressive enhancement only. Every form here still works with
   JavaScript disabled: it posts to /cart/add and lands on /cart.
   ============================================================ */
(function () {
  'use strict';

  var ADD_SELECTOR = 'form[action*="/cart/add"]';

  function routePrefix() {
    // Preserve locale/market path prefixes like /en-ca
    var m = window.location.pathname.match(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i);
    return m ? m[0] : '';
  }

  function flash(btn) {
    if (!btn) return;
    var original = btn.innerHTML;
    btn.classList.add('is-added');
    btn.innerHTML = 'Added ✓';
    setTimeout(function () {
      btn.classList.remove('is-added');
      btn.innerHTML = original;
    }, 1200);
  }

  /* ---------- refresh whatever cart UI the theme provides ---------- */
  function refreshThemeCart() {
    // Dawn / Refresh / Sense / Craft / Studio / Taste and most OS 2.0 themes
    var drawer = document.querySelector('cart-drawer');
    var notification = document.querySelector('cart-notification');

    if (drawer && typeof drawer.renderContents === 'function') {
      return fetchCartSections().then(function (sections) {
        drawer.renderContents({ sections: sections });
      });
    }
    if (notification && typeof notification.renderContents === 'function') {
      return fetchCartSections().then(function (sections) {
        notification.renderContents({ sections: sections });
      });
    }

    // No known drawer — bump the bubble count and let the user carry on.
    return updateCartCount();
  }

  function fetchCartSections() {
    var ids = ['cart-drawer', 'cart-icon-bubble', 'cart-notification', 'cart-live-region-text']
      .filter(function (id) { return document.getElementById('shopify-section-' + id) || document.querySelector(id); });

    return fetch(routePrefix() + '/?sections=' + ids.join(','))
      .then(function (r) { return r.json(); })
      .catch(function () { return {}; });
  }

  function updateCartCount() {
    return fetch(routePrefix() + '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count-bubble span:first-child, [data-cart-count]')
          .forEach(function (el) { el.textContent = cart.item_count; });
      })
      .catch(function () { /* non-fatal */ });
  }

  /* ---------- intercept add-to-cart submits ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches(ADD_SELECTOR)) return;
    if (!form.querySelector('[data-mtc-add]')) return; // only our cards

    e.preventDefault();

    var btn = form.querySelector('[data-mtc-add]');
    if (btn) btn.disabled = true;

    var body = new FormData(form);

    fetch(routePrefix() + '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          // Sold out, quantity limit, etc. Surface the real reason.
          window.alert(res.data.description || res.data.message || 'Sorry, that item could not be added.');
          return;
        }
        flash(btn);
        return refreshThemeCart();
      })
      .catch(function () {
        // Network trouble — fall back to the plain form post.
        form.submit();
      })
      .finally(function () {
        if (btn) btn.disabled = false;
      });
  });

  /* ---------- install-details auto-save on the cart page ---------- */
  function initBookingForm() {
    var form = document.getElementById('mtc-booking-form');
    if (!form) return;

    var saved = document.getElementById('mtc-booking-saved');
    var arrival = document.getElementById('mtc-arrival');
    var depart = document.getElementById('mtc-depart');
    var timer;

    function showSaved() {
      if (!saved) return;
      saved.classList.add('is-visible');
      clearTimeout(timer);
      timer = setTimeout(function () { saved.classList.remove('is-visible'); }, 2200);
    }

    function save() {
      var attributes = {};
      new FormData(form).forEach(function (value, key) {
        var m = key.match(/^attributes\[(.+)\]$/);
        if (m) attributes[m[1]] = value;
      });

      return fetch(routePrefix() + '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attributes })
      })
        .then(showSaved)
        .catch(function () { /* the Save button still works */ });
    }

    // Departure can't precede arrival.
    function syncDates() {
      if (!arrival || !depart) return;
      if (arrival.value) depart.min = arrival.value;
      if (arrival.value && depart.value && depart.value < arrival.value) {
        depart.value = '';
      }
    }

    form.addEventListener('change', function () { syncDates(); save(); });
    form.addEventListener('submit', function (e) {
      // Save via AJAX and stay put rather than round-tripping the page.
      e.preventDefault();
      save();
    });

    syncDates();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBookingForm);
  } else {
    initBookingForm();
  }
})();
